/**
 * Restored WhatsApp floating widget (from theme-legacy).
 */
(function () {
  'use strict';

  function boot() {
    var toggle = document.getElementById('wa-toggle');
    var popup = document.getElementById('wa-popup');
    var close = document.getElementById('wa-close');
    var bubble = document.getElementById('wa-bubble');
    if (!toggle || !popup || !close) return;

    function setOpen(open) {
      popup.classList.toggle('is-open', open);
      popup.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && bubble) {
        bubble.classList.remove('is-visible');
        bubble.hidden = true;
      }
    }

    setTimeout(function () {
      if (!bubble || localStorage.getItem('wa_closed')) return;
      bubble.hidden = false;
      bubble.classList.add('is-visible');
    }, 2500);

    toggle.addEventListener('click', function () {
      setOpen(!popup.classList.contains('is-open'));
    });

    close.addEventListener('click', function () {
      setOpen(false);
      localStorage.setItem('wa_closed', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
